import Controller from './Controller'
export default Controller



// WEBPACK FOOTER //
// ./src/Containers/StatsPivotTables/index.js